import React from 'react';
import { Link } from 'react-router-dom';
import './Privacy.css';

const Privacy = () => {
  return (
    <div className="privacy">
      <Link to="/" className="return-home-button">
        Return Home
      </Link>
      
      {/* Hero Section */}
      <section className="privacy-hero">
        <div className="container">
          <h1>Privacy Policy</h1>
          <p>Your privacy is important to us</p>
        </div>
      </section>

      {/* Content Section */}
      <div className="privacy-content">
          <div className="policy-header">
            <p><strong>Effective Date:</strong> August 5, 2025</p>
            <p><strong>Company:</strong> Flygon LC</p>
            <p><strong>Website:</strong> https://flygonlc.com</p>
            <p><strong>Social Media Platform:</strong> https://postiz-production.up.railway.app</p>
          </div>

          <p>
            At Flygon LC ("Company", "we", "us", or "our"), your privacy is important to us. This Privacy Policy explains how we collect, use, and protect your information when you use our website flygonlc.com and our platform for social media management and scheduling postiz-production.up.railway.app (collectively, the "Services").
          </p>

          <section>
            <h2>1. Information We Collect</h2>
            <p>We may collect the following types of information when you use our Services:</p>
            
            <h3>a. Personal Information</h3>
            <ul>
              <li>Name, email address, and contact details</li>
              <li>Social media account data (e.g., Facebook page/profile IDs, access tokens, profile images)</li>
              <li>Business name, job title, or organization (if applicable)</li>
            </ul>

            <h3>b. Usage Data</h3>
            <ul>
              <li>IP address</li>
              <li>Browser type and version</li>
              <li>Device information</li>
              <li>Time and date of visits</li>
              <li>Pages visited and time spent</li>
            </ul>

            <h3>c. Social Media API Data</h3>
            <p>When you connect your social media accounts (e.g., Facebook), we may collect information via APIs such as:</p>
            <ul>
              <li>Post content</li>
              <li>Scheduling preferences</li>
              <li>Engagement statistics (likes, comments, etc.)</li>
              <li>Permissions granted by the user (e.g., manage_pages, publish_to_groups)</li>
            </ul>
          </section>

          <section>
            <h2>2. How We Use Your Information</h2>
            <p>We use your information to:</p>
            <ul>
              <li>Provide and improve our services</li>
              <li>Schedule and publish social media posts on your behalf</li>
              <li>Manage user accounts and social media permissions</li>
              <li>Send updates, alerts, or important account-related notices</li>
              <li>Comply with legal or regulatory obligations</li>
            </ul>
          </section>

          <section>
            <h2>3. Sharing of Information</h2>
            <p>We do not sell your personal information. We may share your information with:</p>
            <ul>
              <li>Authorized third-party service providers who assist in running our platforms</li>
              <li>Social media APIs (e.g., Facebook Graph API) when posting content on your behalf</li>
              <li>Legal or regulatory authorities if required by law</li>
            </ul>
          </section>

          <section>
            <h2>4. Use of Facebook and Other APIs</h2>
            <ul>
              <li>Our platform at postiz-production.up.railway.app uses the Facebook API and other social media APIs to enable post scheduling and account management.</li>
              <li>By connecting your account, you grant us permission to access and manage content strictly within the scope of the permissions you authorize (e.g., pages_manage_posts, pages_read_engagement).</li>
              <li>We only use these permissions to deliver requested functionality and never store more data than necessary.</li>
            </ul>
          </section>

          <section>
            <h2>5. Data Retention</h2>
            <p>We retain your data only for as long as needed to:</p>
            <ul>
              <li>Provide our services</li>
              <li>Comply with legal obligations</li>
              <li>Resolve disputes or enforce our agreements</li>
            </ul>
            <p>You may request deletion of your account or connected social media data at any time by contacting us.</p>
          </section>

          <section>
            <h2>6. Security</h2>
            <p>We take appropriate technical and organizational measures to protect your information from unauthorized access, disclosure, alteration, or destruction.</p>
          </section>

          <section>
            <h2>7. Your Rights</h2>
            <p>You have the right to:</p>
            <ul>
              <li>Access the personal data we hold about you</li>
              <li>Request correction or deletion of your data</li>
              <li>Withdraw social media permissions at any time</li>
              <li>Lodge a complaint with a data protection authority</li>
            </ul>
          </section>

          <section>
            <h2>8. Third-Party Links</h2>
            <p>Our Services may contain links to external sites not operated by us. We are not responsible for the content or privacy practices of those sites.</p>
          </section>

          <section>
            <h2>9. Children's Privacy</h2>
            <p>Our Services are not intended for children under 13. We do not knowingly collect personal data from children.</p>
          </section>

          <section>
            <h2>10. Changes to This Privacy Policy</h2>
            <p>We may update this Privacy Policy from time to time. We will post the updated version with a new "Effective Date" on this page. Continued use of our Services indicates acceptance of the updated policy.</p>
          </section>

          <section>
            <h2>11. Contact Us</h2>
            <p>If you have questions about this Privacy Policy or wish to exercise your rights, contact us at:</p>
            <p>
              <strong>Flygon LC</strong><br />
              Email: info@flygonlc.com
            </p>
          </section>
      </div>
    </div>
  );
};

export default Privacy;

